import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-zinc-200 px-4 sm:px-8 py-4 flex items-center justify-between">
        <Link to="/" className="font-heading font-bold text-sm flex items-center gap-2 hover:text-[#002FA7]">
          <ArrowLeft size={14} /> Zurück zur Startseite
        </Link>
        <div className="text-[10px] uppercase tracking-widest text-zinc-500">NutriCalc · Rechtliches</div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">{title}</h1>
        <div className="prose-sm max-w-none text-sm text-zinc-700 leading-relaxed space-y-4 [&_h2]:font-heading [&_h2]:text-lg [&_h2]:font-bold [&_h2]:mt-8 [&_h2]:mb-2 [&_h3]:font-bold [&_h3]:mt-4 [&_h3]:mb-1 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_strong]:font-bold">
          {children}
        </div>
        <div className="mt-10 pt-6 border-t border-zinc-200 text-xs text-zinc-400">
          Letzte Aktualisierung: {new Date().toLocaleDateString("de-DE")}
        </div>
      </main>
    </div>
  );
}

export function Imprint() {
  return (
    <LegalPage title="Impressum">
      <h2>Angaben gemäß §5 TMG</h2>
      <p>
        <strong>NutriCalc</strong> — eine Software-Lösung von:<br />
        <strong>Vahit Sarpkaya</strong><br />
        Wolfgangstr. 1<br />
        72793 Pfullingen<br />
        Deutschland
      </p>

      <h2>Vertreten durch</h2>
      <p>Vahit Sarpkaya (Einzelunternehmer / Inhaber)</p>

      <h2>Kontakt</h2>
      <p>
        E-Mail: <a href="mailto:vahits@icloud.com" className="text-[#002FA7] underline">vahits@icloud.com</a>
      </p>

      <h2>Umsatzsteuer</h2>
      <p>
        Gemäß §19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer berechnet und
        ausgewiesen.
      </p>

      <h2>Registereintrag</h2>
      <p>
        Als Einzelunternehmer besteht keine Eintragungspflicht im Handelsregister.
      </p>

      <h2>Verantwortlich für den Inhalt nach §18 Abs. 2 MStV</h2>
      <p>
        Vahit Sarpkaya<br />
        Wolfgangstr. 1, 72793 Pfullingen
      </p>

      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-[#002FA7] underline">
          https://ec.europa.eu/consumers/odr
        </a>.<br />
        Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß §7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten
        nach den allgemeinen Gesetzen verantwortlich. Nach §§8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
        Informationen zu überwachen.
      </p>
      <p>
        Die in NutriCalc ausgewiesenen Nährwerte basieren ausschließlich auf den vom Nutzer
        hinterlegten Zutatendaten. Eine Gewähr für die Korrektheit der Nährwertberechnung
        zu Etikettierungs- oder Deklarationszwecken (VO 1169/2011) wird nicht übernommen.
        Die abschließende Endprüfung verbleibt beim Inverkehrbringer des Lebensmittels.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir
        keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
        Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
        Anbieter oder Betreiber der Seiten verantwortlich.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung
        und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    </LegalPage>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Datenschutzerklärung">
      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung im Sinne von Art. 4 Nr. 7 DSGVO ist:
      </p>
      <p>
        <strong>Vahit Sarpkaya</strong><br />
        Wolfgangstr. 1<br />
        72793 Pfullingen<br />
        E-Mail: <a href="mailto:vahits@icloud.com" className="text-[#002FA7] underline">vahits@icloud.com</a>
      </p>

      <h2>2. Welche Daten wir verarbeiten</h2>
      <p>
        NutriCalc ist eine SaaS-Anwendung zur Berechnung von Nährwerten in der Lebensmittelproduktion.
        Wir verarbeiten ausschließlich die für den Betrieb erforderlichen Daten:
      </p>
      <ul>
        <li><strong>Registrierungsdaten:</strong> Firmenname, voller Name, geschäftliche E-Mail, optional Telefon, Branche, Mitarbeiterzahl.</li>
        <li><strong>Benutzerkonto:</strong> Benutzername, gehashtes Passwort (bcrypt), Admin-Status, Erstellungsdatum, Zeitpunkt der AGB-Zustimmung.</li>
        <li><strong>Inhaltliche Daten:</strong> selbst angelegte Zutaten, Rezepte, Versionen, Firmenlogo.</li>
        <li><strong>Audit-Metadaten:</strong> wer hat wann welchen Eintrag erstellt oder verändert.</li>
        <li><strong>Authentifizierungs-Token:</strong> ein zeitlich begrenztes JSON-Web-Token (12 Std.) im Cookie und LocalStorage.</li>
        <li><strong>Server-Logs:</strong> technisch notwendige Zugriffslogs (IP, Zeitstempel, Endpoint) — automatisch nach 30 Tagen gelöscht.</li>
        <li><strong>Cookie-Einwilligung:</strong> deine Auswahl im Cookie-Banner (LocalStorage, ohne personenbezogene Daten).</li>
      </ul>

      <h2>3. Zwecke der Verarbeitung</h2>
      <ul>
        <li>Bereitstellung und Nutzung der Software NutriCalc.</li>
        <li>Vertragsabwicklung (kostenpflichtiger Plan ab Tag 8 nach Registrierung).</li>
        <li>Sicherheit, Audit, Stabilität, Missbrauchs-Prävention.</li>
        <li>Kommunikation per E-Mail (Service-Mails, optional Newsletter mit Einwilligung).</li>
      </ul>

      <h2>4. Rechtsgrundlagen</h2>
      <ul>
        <li>Art. 6 Abs. 1 lit. b DSGVO — Vertragserfüllung.</li>
        <li>Art. 6 Abs. 1 lit. f DSGVO — berechtigtes Interesse (Sicherheit, Audit, Stabilität).</li>
        <li>Art. 6 Abs. 1 lit. a DSGVO — Einwilligung (Newsletter, optionale Cookies).</li>
        <li>Art. 6 Abs. 1 lit. c DSGVO — gesetzliche Pflicht (Aufbewahrungspflichten).</li>
      </ul>

      <h2>5. Empfänger / Auftragsverarbeitung</h2>
      <p>
        Die Daten werden auf folgender Infrastruktur verarbeitet:
      </p>
      <ul>
        <li>
          <strong>Hosting &amp; Datenbank:</strong> Emergent Labs Inc. (emergent.sh) als
          Auftragsverarbeiter im Sinne von Art. 28 DSGVO. Der konkrete Standort der
          eingesetzten Rechenzentren wird im Auftragsverarbeitungsvertrag zwischen
          Verantwortlichem und Emergent geregelt; Anfragen hierzu bitte per
          E-Mail an den Verantwortlichen.
        </li>
      </ul>
      <p>
        Mit Emergent Labs Inc. besteht ein Auftragsverarbeitungsvertrag nach Art. 28
        DSGVO. Eine Weitergabe an Dritte zu Marketingzwecken erfolgt <strong>nicht</strong>.
        Falls personenbezogene Daten in Drittländer (außerhalb der EU/EWR) übermittelt
        werden sollten, geschieht dies ausschließlich auf Grundlage der EU-Standardvertragsklauseln
        (Art. 46 Abs. 2 lit. c DSGVO).
      </p>

      <h2>6. Speicherdauer</h2>
      <ul>
        <li>Benutzerkonten & Firmen: bis zur Löschung durch dich oder uns nach Vertragsende.</li>
        <li>Zutaten / Rezepte / Versionen: bis zur manuellen Löschung oder Account-Schließung.</li>
        <li>Server-Logs: maximal 30 Tage.</li>
        <li>Auth-Token: 12 Stunden ab Anmeldung.</li>
        <li>Newsletter-Einwilligungen: bis zum Widerruf.</li>
      </ul>

      <h2>7. Deine Rechte</h2>
      <p>Du hast nach DSGVO folgende Rechte:</p>
      <ul>
        <li>Auskunft (Art. 15) — komplette Datenkopie anfordern.</li>
        <li>Berichtigung (Art. 16).</li>
        <li>Löschung (Art. 17, &bdquo;Recht auf Vergessenwerden&ldquo;).</li>
        <li>Einschränkung der Verarbeitung (Art. 18).</li>
        <li>Datenübertragbarkeit (Art. 20).</li>
        <li>Widerspruch (Art. 21).</li>
        <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3) — z. B. Newsletter, jederzeit per E-Mail.</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77) — für Baden-Württemberg zuständig:{" "}
          <a href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank" rel="noreferrer" className="text-[#002FA7] underline">
            Landesbeauftragter für den Datenschutz und die Informationsfreiheit Baden-Württemberg
          </a>.
        </li>
      </ul>
      <p>
        Anfragen bitte an: <a href="mailto:vahits@icloud.com" className="text-[#002FA7] underline">vahits@icloud.com</a>
      </p>

      <h2>8. Cookies & Local Storage</h2>
      <p>
        NutriCalc verwendet folgende Speicherobjekte:
      </p>
      <h3>Technisch notwendig (keine Einwilligung erforderlich)</h3>
      <ul>
        <li><code>access_token</code> (HttpOnly-Cookie, 12 Std.) — Sitzungs-Token.</li>
        <li><code>nc_token</code> (LocalStorage) — Kopie für API-Aufrufe.</li>
        <li><code>nc_cookie_consent</code> (LocalStorage) — deine Cookie-Auswahl.</li>
      </ul>
      <h3>Optional (nur mit Einwilligung)</h3>
      <ul>
        <li>Funktionale Cookies — UI-Einstellungen (Filter, Sortierung).</li>
        <li>Statistik-Cookies — anonyme Nutzungs-Statistiken zur Produktverbesserung.</li>
      </ul>
      <p>
        Du kannst deine Auswahl jederzeit über den Link &bdquo;Cookie-Einstellungen&ldquo; im Footer ändern.
      </p>

      <h2>9. Sicherheit</h2>
      <ul>
        <li>Verschlüsselter Transport (HTTPS/TLS).</li>
        <li>Passwörter werden ausschließlich als bcrypt-Hash gespeichert.</li>
        <li>Strikte Mandanten-Isolation (Multi-Tenancy) — kein Zugriff auf fremde Firmen-Daten.</li>
        <li>Zugriff nur für authentifizierte Benutzer; Adminbereich nur für Administratoren.</li>
        <li>Regelmäßige Backups durch den Hosting-Anbieter.</li>
      </ul>

      <h2>10. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung bei Änderungen der Rechtslage oder
        unserer Funktionen anzupassen. Über wesentliche Änderungen informieren wir dich
        rechtzeitig per E-Mail.
      </p>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Allgemeine Geschäftsbedingungen (AGB)">
      <h2>1. Geltungsbereich & Vertragspartner</h2>
      <p>
        Diese AGB regeln die Nutzung der Software <strong>NutriCalc</strong>, betrieben durch:
      </p>
      <p>
        Vahit Sarpkaya, Wolfgangstr. 1, 72793 Pfullingen (im Folgenden &bdquo;Anbieter&ldquo;).
      </p>
      <p>
        Mit der Registrierung erklärst du dich (im Folgenden &bdquo;Nutzer&ldquo;) mit diesen
        Bedingungen einverstanden. Die Software richtet sich ausschließlich an
        Unternehmer im Sinne von §14 BGB.
      </p>

      <h2>2. Vertragsgegenstand</h2>
      <p>
        NutriCalc ist eine Cloud-basierte SaaS-Software zur Berechnung von Nährwerten,
        Allergenen und Nutri-Score in der Lebensmittelproduktion gemäß EU-Verordnung
        1169/2011 sowie zur Verwaltung von Zutaten, Rezepten und Versionierung mit Audit-Trail.
      </p>

      <h2>3. Vertragsschluss</h2>
      <p>
        Der Vertrag kommt mit der erfolgreichen Registrierung zustande. Die Bestätigung
        erfolgt durch Anlage des Accounts und E-Mail-Mitteilung.
      </p>

      <h2>4. Testphase</h2>
      <p>
        Der Nutzer erhält nach Registrierung eine kostenfreie Testphase von <strong>7 Tagen</strong>.
        Während der Testphase stehen alle Funktionen vollumfänglich zur Verfügung.
        Eine Kündigung in der Testphase ist jederzeit ohne Angabe von Gründen möglich.
      </p>

      <h2>5. Preise & Zahlungsbedingungen</h2>
      <p>
        Nach Ablauf der Testphase ist die Nutzung kostenpflichtig:
      </p>
      <ul>
        <li><strong>Team-Plan: 149,00 € / Monat</strong> für bis zu 5 Nutzer.</li>
        <li>Gemäß §19 UStG wird keine Umsatzsteuer berechnet.</li>
        <li>Zahlung monatlich im Voraus per SEPA-Lastschrift oder Überweisung.</li>
        <li>Bei Zahlungsverzug behält sich der Anbieter vor, den Zugang nach vorheriger
          Mahnung vorübergehend zu sperren.</li>
      </ul>

      <h2>6. Vertragslaufzeit & Kündigung</h2>
      <p>
        Der Vertrag wird auf unbestimmte Zeit geschlossen und kann mit einer Frist von
        <strong> 14 Tagen zum Monatsende</strong> gekündigt werden. Die Kündigung erfolgt
        per E-Mail an <a href="mailto:vahits@icloud.com" className="text-[#002FA7] underline">vahits@icloud.com</a> oder
        durch Account-Löschung im Kunden-Dashboard.
      </p>

      <h2>7. Pflichten des Nutzers</h2>
      <ul>
        <li>Sorgfältige und wahrheitsgemäße Eingabe von Zutaten- und Nährwertdaten.</li>
        <li>Geheimhaltung der Zugangsdaten; Weitergabe ist untersagt.</li>
        <li>Keine missbräuchliche oder rechtswidrige Nutzung der Software.</li>
        <li>Keine Speicherung urheberrechtlich geschützter, fremder Daten ohne Berechtigung.</li>
      </ul>

      <h2>8. Datenrichtigkeit & Haftung</h2>
      <p>
        Die Nährwertberechnung erfolgt <strong>ausschließlich anhand der vom Nutzer
        eingegebenen Werte</strong>. Der Anbieter übernimmt <strong>keine Haftung</strong> für
        die inhaltliche Richtigkeit dieser Eingabewerte oder der daraus resultierenden
        Ergebnisse.
      </p>
      <p>
        Eine abschließende Plausibilitäts- und Konformitätsprüfung — insbesondere für
        Etikettierungs- und Deklarationszwecke nach VO 1169/2011 — obliegt allein dem
        Inverkehrbringer des Lebensmittels.
      </p>
      <p>
        Der Anbieter haftet nur für Vorsatz und grobe Fahrlässigkeit. Eine darüber hinausgehende
        Haftung — insbesondere für mittelbare Schäden, entgangenen Gewinn oder Folgeschäden
        wie z. B. Rückrufaktionen — ist ausgeschlossen, soweit gesetzlich zulässig.
      </p>

      <h2>9. Haftungsausschluss</h2>
      <h3>Wichtiger Hinweis zur Nutzung der Software</h3>
      <p>
        NutriCalc dient ausschließlich der Unterstützung bei der Berechnung von Nährwerten,
        Allergenen, Zutatenverzeichnissen, Nutri-Score-Werten sowie weiteren lebensmittelbezogenen
        Kennzeichnungen und Auswertungen.
      </p>
      <p>
        Die durch die Software erzeugten Ergebnisse basieren auf den vom Nutzer eingegebenen
        Daten sowie den in der Software hinterlegten Berechnungs- und Datenmodellen. Trotz
        größtmöglicher Sorgfalt bei Entwicklung, Pflege und Aktualisierung der Software kann
        keine Gewähr für die Vollständigkeit, Richtigkeit, Aktualität oder rechtliche
        Verwendbarkeit der bereitgestellten Ergebnisse übernommen werden.
      </p>
      <p>
        <strong>Die Nutzung der Software erfolgt auf eigene Verantwortung des Nutzers.</strong>
      </p>

      <h3>Verantwortung des Nutzers</h3>
      <p>Der Nutzer ist allein verantwortlich für:</p>
      <ul>
        <li>die Richtigkeit, Vollständigkeit und Aktualität sämtlicher eingegebener Daten,</li>
        <li>die Überprüfung aller Berechnungsergebnisse,</li>
        <li>die Kontrolle aller Nährwertangaben,</li>
        <li>die Prüfung aller Allergenkennzeichnungen,</li>
        <li>die Überprüfung von Zutatenlisten,</li>
        <li>die Einhaltung gesetzlicher Kennzeichnungspflichten,</li>
        <li>die rechtliche Zulässigkeit aller veröffentlichten oder verwendeten Angaben.</li>
      </ul>
      <p>
        Vor der Verwendung auf Verpackungen, Etiketten, Speisekarten, Produktdatenblättern,
        Online-Shops oder sonstigen Veröffentlichungen sind sämtliche Ausgaben der Software
        durch den Nutzer eigenständig fachlich und rechtlich zu prüfen.
      </p>

      <h3>Keine Rechts- oder Fachberatung</h3>
      <p>
        NutriCalc stellt keine Rechtsberatung, Lebensmittelrechtsberatung,
        Qualitätsmanagement-Beratung, Laboranalyse oder sonstige fachliche Beratung dar.
      </p>
      <p>Die Nutzung der Software ersetzt insbesondere nicht die Prüfung durch:</p>
      <ul>
        <li>Lebensmittelunternehmer,</li>
        <li>Qualitätsmanager,</li>
        <li>Lebensmittelchemiker,</li>
        <li>Ökotrophologen,</li>
        <li>Sachverständige,</li>
        <li>Rechtsanwälte oder andere qualifizierte Fachpersonen.</li>
      </ul>

      <h3>Hinweis zur Gesetzeskonformität</h3>
      <p>
        NutriCalc unterstützt die Erstellung von Kennzeichnungen und Deklarationen auf
        Grundlage geltender gesetzlicher Anforderungen und anerkannter Berechnungsmethoden.
      </p>
      <p>Eine Garantie oder Zusicherung der rechtlichen Konformität, insbesondere hinsichtlich:</p>
      <ul>
        <li>LMIV (EU-Verordnung 1169/2011),</li>
        <li>nationaler Kennzeichnungsvorschriften,</li>
        <li>lebensmittelrechtlicher Vorgaben,</li>
        <li>behördlicher Anforderungen,</li>
        <li>Zertifizierungen,</li>
        <li>Audits,</li>
      </ul>
      <p>
        wird ausdrücklich nicht übernommen. Die abschließende rechtliche und fachliche
        Prüfung sämtlicher Ergebnisse obliegt ausschließlich dem Nutzer.
      </p>

      <h3>Allergene und Unverträglichkeiten</h3>
      <p>
        Allergeninformationen werden ausschließlich anhand der vom Nutzer bereitgestellten
        Daten und der hinterlegten Datenbasis ermittelt.
      </p>
      <p>
        Eine vollständige Erfassung aller Allergene, Spuren, Kreuzkontaminationen oder
        produktspezifischen Besonderheiten kann nicht garantiert werden.
      </p>
      <p>
        Der Nutzer ist verpflichtet, sämtliche Allergeninformationen eigenständig zu prüfen
        und vor Verwendung zu validieren. Jegliche Haftung für Schäden, die aus fehlerhaften
        oder unvollständigen Allergenangaben entstehen, wird im gesetzlich zulässigen Umfang
        ausgeschlossen.
      </p>

      <h3>Haftungsbeschränkung</h3>
      <p>Soweit gesetzlich zulässig, haftet der Anbieter nicht für:</p>
      <ul>
        <li>fehlerhafte Berechnungsergebnisse,</li>
        <li>fehlerhafte Kennzeichnungen,</li>
        <li>behördliche Beanstandungen,</li>
        <li>Bußgelder,</li>
        <li>Rückrufaktionen,</li>
        <li>Produktionsausfälle,</li>
        <li>Umsatzausfälle,</li>
        <li>entgangenen Gewinn,</li>
        <li>mittelbare Schäden,</li>
        <li>Folgeschäden,</li>
        <li>Schäden aufgrund fehlerhafter Nutzereingaben.</li>
      </ul>
      <p>Die Haftung bleibt unberührt bei:</p>
      <ul>
        <li>Vorsatz,</li>
        <li>grober Fahrlässigkeit,</li>
        <li>Schäden aus der Verletzung von Leben, Körper oder Gesundheit,</li>
        <li>zwingenden gesetzlichen Haftungsvorschriften.</li>
      </ul>

      <h3>Datenquellen</h3>
      <p>
        Die in NutriCalc verwendeten Nährwert- und Produktdaten stammen aus unterschiedlichen
        Quellen und Datenbanken. Für die Vollständigkeit, Aktualität und Richtigkeit dieser
        Daten wird keine Gewähr übernommen. Der Nutzer hat die Pflicht, sämtliche Daten vor
        ihrer Verwendung eigenständig zu überprüfen.
      </p>

      <h3>Hinweis für Exporte und Dokumente</h3>
      <p>
        Alle durch NutriCalc erzeugten Dokumente, Berichte, Etiketten, Nährwerttabellen und
        Kennzeichnungen dienen ausschließlich als Arbeits- und Berechnungsgrundlage. Vor
        Veröffentlichung oder Verwendung sind sämtliche Inhalte durch den Nutzer
        eigenständig fachlich und rechtlich zu prüfen.
      </p>

      <h2>10. Verfügbarkeit</h2>
      <p>
        Der Anbieter bemüht sich um eine möglichst hohe Verfügbarkeit von 99,0 % im Jahresmittel,
        garantiert jedoch keine ununterbrochene Erreichbarkeit. Wartungsfenster werden
        soweit möglich vorab angekündigt.
      </p>

      <h2>11. Datenschutz & Datensicherheit</h2>
      <p>
        Es gelten die Bestimmungen unserer{" "}
        <Link to="/datenschutz" className="text-[#002FA7] underline">Datenschutzerklärung</Link>.
        Der Nutzer bestätigt, dass er befugt ist, die im Rahmen der Nutzung von ihm
        eingegebenen Daten in die Software einzustellen.
      </p>

      <h2>12. Datenexport & Beendigung</h2>
      <p>
        Bei Beendigung des Vertrags hat der Nutzer das Recht, seine Daten innerhalb von
        30 Tagen nach Vertragsende per Export herunterzuladen (PDF, Excel). Nach Ablauf
        dieser Frist werden alle personenbezogenen Daten und Inhalte gelöscht, sofern
        keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>

      <h2>12. Änderungen der AGB</h2>
      <p>
        Der Anbieter kann diese AGB anpassen. Wesentliche Änderungen werden mindestens
        4 Wochen vor Inkrafttreten per E-Mail mitgeteilt. Bei Widerspruch innerhalb dieser
        Frist endet der Vertrag zum Zeitpunkt des Inkrafttretens der Änderungen.
      </p>

      <h2>14. Schlussbestimmungen</h2>
      <p>
        Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand für alle
        Streitigkeiten ist — soweit gesetzlich zulässig — Reutlingen / Pfullingen.
      </p>
      <p>
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt.
      </p>
    </LegalPage>
  );
}
